import { type } from "jquery"
import { typesPrincipal } from "./PrincipalReducer";

const init = {
    Open: false,
    Titulo: "",
    Content: null,
    Cerrar: null,
    Height: "auto",
    TieneBotonCerrar: false,
}
export const PopupReducer = (state = init, action) => {
    switch (action.type) {
        case typesPopup.Open: return {
            ...state,
            ...action.payload,
            Open: true,
        }
        case typesPopup.Cerrar:
            if (state.Cerrar) {
                setTimeout(() => {
                    state.Cerrar(action.payload)
                }, 100);
            }
            return { ...init };
        default: return state;
    }
}
/* ### Actions ### */
export const MostrarPopup = (params) => {
    return {
        type: typesPopup.Open,
        payload: { ...params }
    }
}
export const CerrarPopup = (result = null) => {
    return { type: typesPopup.Cerrar, payload: result }
}
/* ### Actions ### */

/* ### Types de Inicio ### */
export const typesPopup = {
    Open: '[Popup] Open Popup',
    Cerrar: '[Popup] Cerrar Popup',
}
/* ### Types de Inicio ### */